<script>
    import Layout from "../../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Loader from "../../../../components/widgets/loader";
    import Forms from "../../../../mixins/Forms";

    import axios from 'axios';

    /**
     * View Twilio phone numbers component
     */
    export default {
        page: {
            title: "All Offices",
            meta: [{name: "description", content: appConfig.description}]
        },
        mixins: [Forms],
        components: {Layout, PageHeader, Loader},
        data() {
            return {
                title: "All Offices",
                items: [
                    {
                        text: "Settings",
                        href: "#"
                    },
                    {
                        text: "All Offices",
                        active: true
                    }
                ],

                isLoading: false,
                offices: null,
                serverErrors: []
            };
        },
        methods: {
            loadOffices() {
                let vm = this;
                vm.isLoading = true;

                vm.isSaving = true;
                axios.get(API_BASE + '/offices/').then(r => {
                    vm.isLoading = false;
                    vm.offices = r.data;
                }).catch(e => {
                    console.log(e);
                    vm.isLoading = false;
                    vm.setErrors(e);
                });
            }
        },
        created() {
            this.loadOffices();
        }
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items"/>
        <errors :error-list="serverErrors"></errors>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div v-if="isLoading" class="text-center">
                            <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
                        </div>

                        <div v-if="!isLoading" class="table-responsive mb-0">
                            <table class="table mb-0 table-centered">
                                <thead class="thead-light">
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(office, i) in offices" :key="`office-${i}`">
                                    <th scope="row">{{ office.id }}</th>
                                    <td>{{ office.name }}</td>
                                    <td class="text-right">
                                        <!-- Button trigger modal -->
                                        <button
                                                type="button"
                                                class="btn btn-itg btn-sm"
                                                @click="$router.push('/settings/offices/'+office.id+'/edit')"
                                        >
                                            Edit
                                        </button>
                                    </td>
                                </tr>
                                <tr v-if="offices.length === 0">
                                    <th scope="row" colspan="3">
                                        <span class="text-danger">No results</span>
                                    </th>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>

                <a href="#" class="btn btn-itg-dark"
                   @click.prevent="$router.push('/settings/offices/create')">Add
                    Office
                </a>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>
